import React from 'react';

export type StatusKind = 'success' | 'info' | 'warning' | 'error';

interface Props {
    kind?: StatusKind;
    children: React.ReactNode;
    className?: string;
    dismissible?: boolean;
    onClose?: () => void;
}

export const StatusMessage: React.FC<Props> = ({ kind = 'info', children, className, dismissible = true, onClose }) => {
    const [visible, setVisible] = React.useState(true);
    const base = 'status-message';
    const kindClass = `status-message--${kind}`;

    const handleClose = () => {
        setVisible(false);
        if (onClose) onClose();
    };

    if (!visible) return null;

    return (
        <div role="status" aria-live={kind === 'error' || kind === 'warning' ? 'assertive' : 'polite'} className={`${base} ${kindClass} ${className || ''}`.trim()}>
            <div className="status-message__content">{children}</div>
            {dismissible && (
                <button type="button" aria-label="Close" className="btn__close se-icon--close status-message__close" onClick={handleClose} />
            )}
        </div>
    );
};

export default StatusMessage;
